import React from 'react'
import BaseCopilotInsightWidget from './BaseCopilotInsightWidget'
import IconAndText from 'components/common/IconAndText'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { Skeleton } from '@material-ui/lab'
import LinkButton from 'components/common/buttons/LinkButton'
import { Grid } from '@material-ui/core'
import { ChevronDownSmall } from 'components/common/icons'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const BaseAISummaryWidget = ({
  title,
  titleIcon,
  buttonLabel,
  onButtonClick = () => {},
  isLoading,
  children,
  updatedAt
}) => {
  const { t } = useTranslation()

  return isLoading ? (
    <Skeleton width="100%" height="170px" style={{ borderRadius: 16 }} />
  ) : (
    <BaseCopilotInsightWidget>
      <Grid container direction="column" spacing={1} style={{ height: '100%' }}>
        <Grid item>
          <IconAndText
            margin="10px"
            icon={titleIcon}
            text={
              <DazzedParagraph14 color="var(--text-color-11)" bold>
                {title}
              </DazzedParagraph14>
            }
          />
        </Grid>
        <Grid item>{children}</Grid>
        <Grid item>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <LinkButton
                bold
                fontSize={14}
                underline
                label={buttonLabel}
                onClick={onButtonClick}
                icon={<ChevronDownSmall fill="#3C52EF" style={{ transform: 'rotate(-90deg)' }} />}
                containerDirection="row-reverse"
                containerJustifyContent="flex-end"
              />
            </Grid>
            {updatedAt && (
              <Grid item>
                <DazzedParagraph14 color="#95A4C1">
                  {t('pages.patients.patientSidebar.items.copilot.copilotInsights.lastUpdated', {
                    updatedAt: moment(updatedAt).format('LL')
                  })}
                </DazzedParagraph14>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </BaseCopilotInsightWidget>
  )
}

export default BaseAISummaryWidget
